import React, { FC } from 'react';
import { Grid, GridExtendedProps } from 'grommet';

const GridComponent: FC<GridExtendedProps> = ({ children, ...props }) => {
  return <Grid {...props}>{children}</Grid>;
};

export default GridComponent;
